import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import 'firebase/compat/auth';

const firebaseConfig = {
    apiKey: "AIzaSyCw3Uk5n2suumwLSnC80-Wg3eyL5qhUZuI",
    authDomain: "todoapp-22e95.firebaseapp.com",
    projectId: "todoapp-22e95",
    storageBucket: "todoapp-22e95.appspot.com",
    messagingSenderId: "790983761401",
    appId: "1:790983761401:web:7bb48b2a88b78b88b0b128"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default firebase;  
export const db = firebase.firestore();
export const auth = firebase.auth();
// export const storage = firebase.storage();
// export const auth = firebase.auth();